import { useEffect, useState } from "react";
import { LuImageOff } from "react-icons/lu";
import { TRYON_SERVER_URL } from "../config";
import { fetchAssetBlobUrl } from "./api";

function isLocal(url) {
    return url.startsWith("blob:") || url.startsWith("data:");
}

export function absoluteUrl(url) {
    return url.startsWith("/") ? `${TRYON_SERVER_URL}${url}` : url;
}

/** Resolves a (possibly auth-protected) asset URL into one the browser can render. */
export function useResolvedUrl(src) {
    const [state, setState] = useState(() => (isLocal(src) ? { url: src } : { url: null }));

    useEffect(() => {
        if (isLocal(src)) {
            setState({ url: src });
            return undefined;
        }
        let cancelled = false;
        let objectUrl = null;
        setState({ url: null });
        fetchAssetBlobUrl(absoluteUrl(src))
            .then((url) => {
                objectUrl = url;
                if (cancelled) URL.revokeObjectURL(url);
                else setState({ url });
            })
            .catch(() => {
                if (!cancelled) setState({ url: null, failed: true });
            });
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [src]);

    return state;
}

export default function AuthMedia({ kind, src, alt, className, onOpen }) {
    const { url, failed } = useResolvedUrl(src);

    if (failed) {
        return (
            <div className="flex h-40 w-64 max-w-full items-center justify-center rounded-2xl bg-[var(--field-bg)] text-[var(--text-tertiary)]">
                <LuImageOff size={20} />
            </div>
        );
    }
    if (!url) {
        return <div className="h-40 w-72 max-w-full animate-pulse rounded-2xl bg-[var(--bg-secondary)]" />;
    }
    if (kind === "video") {
        return <video src={url} controls className={className} />;
    }
    return (
        <button
            type="button"
            onClick={() => onOpen?.(url)}
            aria-label={`View ${alt} full screen`}
            className="block w-fit max-w-full cursor-zoom-in border-0 bg-transparent p-0 leading-none focus:outline-none focus-visible:shadow-[var(--ring)]"
        >
            <img src={url} alt={alt} className={className} />
        </button>
    );
}
